import React, { useState, useEffect } from "react";

import logo from "../../assets/images/logo-black.png";
const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);
  return (
    <header
      id="topnav"
      className={`defaultscroll sticky${scrolled ? " nav-sticky" : ""}`}
    >
      <div className="container">
        {/* Logo container*/}
        <a className="logo" href="#">
          <span className="logo-light-mode">
            <img
              src={logo}
              className="l-dark"
              height={24}
              alt=""
              style={{ maxWidth: "220px" }}
            />
            <img
              src={logo}
              className="l-light"
              height={24}
              alt=""
              style={{ maxWidth: "220px" }}
            />
          </span>
          <img
            src={logo}
            height={24}
            className="logo-dark-mode"
            alt=""
            style={{ maxWidth: "220px" }}
          />
        </a>

        {/*end navigation*/}
      </div>
      {/*end container*/}
    </header>
  );
};

export default Header;
